import React from "react";

export type InstagramLogoProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 15,
    height: 15,
  },
  medium: {
    width: 24,
    height: 24,
  },
  large: {
    width: 60,
    height: 60,
  },
};

export const InstagramLogo = React.forwardRef<
  SVGSVGElement,
  InstagramLogoProps
>((props, ref) => {
  const { size = "medium", width, height, color = "black" } = props;
  const svgSize = width && height ? { width, height } : sizes[size];

  return (
    <svg
      ref={ref}
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 27.5 27.5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5 0.250244H6.5C5.67924 0.250244 4.86651 0.411905 4.10823 0.725997C3.34994 1.04009 2.66095 1.50046 2.08058 2.08083C0.90848 3.25293 0.25 4.84264 0.25 6.50024V21.5002C0.25 22.321 0.411661 23.1337 0.725753 23.892C1.03984 24.6503 1.50022 25.3393 2.08058 25.9197C3.25269 27.0918 4.8424 27.7502 6.5 27.7502H21.5C22.3208 27.7502 23.1335 27.5886 23.8918 27.2745C24.6501 26.9604 25.3391 26.5 25.9194 25.9197C26.4998 25.3393 26.9602 24.6503 27.2743 23.892C27.5883 23.1337 27.75 22.321 27.75 21.5002V6.50024C27.75 5.67948 27.5883 4.86676 27.2743 4.10847C26.9602 3.35019 26.4998 2.66119 25.9194 2.08083C25.3391 1.50046 24.6501 1.04009 23.8918 0.725997C23.1335 0.411905 22.3208 0.250244 21.5 0.250244ZM5.25 6.50024C5.00277 6.50024 4.7611 6.42693 4.55554 6.28958C4.34998 6.15223 4.18976 5.95701 4.09515 5.7286C4.00054 5.50019 3.97579 5.24886 4.02402 5.00638C4.07225 4.7639 4.1913 4.54118 4.36612 4.36636C4.54093 4.19155 4.76366 4.07249 5.00614 4.02426C5.24861 3.97603 5.49995 4.00078 5.72835 4.09539C5.95676 4.19 6.15199 4.35022 6.28934 4.55578C6.42669 4.76134 6.5 5.00302 6.5 5.25024C6.5 5.58176 6.3683 5.89971 6.13388 6.13413C5.89946 6.36855 5.58152 6.50024 5.25 6.50024ZM14 21.5002C12.5166 21.5002 11.0666 21.0604 9.83322 20.2363C8.59986 19.4122 7.63856 18.2408 7.0709 16.8704C6.50325 15.4999 6.35472 13.9919 6.64411 12.5371C6.9335 11.0822 7.64781 9.74584 8.6967 8.69694C9.74559 7.64805 11.082 6.93374 12.5368 6.64435C13.9917 6.35496 15.4997 6.50349 16.8701 7.07115C18.2406 7.6388 19.4119 8.6001 20.236 9.83347C21.0601 11.0668 21.5 12.5169 21.5 14.0002C21.5 15.9894 20.7098 17.897 19.3033 19.3035C17.8968 20.7101 15.9891 21.5002 14 21.5002Z"
        fill={color}
      />
    </svg>
  );
});

InstagramLogo.displayName = "InstagramLogo";
